<template>
  <Modal
    modalType="EditBoardMetadata"
    mayCancel="false"
    v-on:done="onDone"
    verticalAlign="flex-start"
  >
    <h2>Enter your name</h2>
    <form v-on:submit.prevent="onDone">
      <p>
        <input ref="nameField" type="text" v-model="username" />
      </p>

      <div class="BottomRow">
        <button
          class="WBMBigButton m-primary"
          :disabled="maySubmit"
          type="submit"
        >
          Save
        </button>
        <a class="WBMBigButton" v-bind:href="loginURL">Log in</a>
      </div>
    </form>
  </Modal>
</template>

<script lang="ts">
import { Component, Emit, Ref } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import { UserMutations } from "@/store/modules/user";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Modal } })
export default class EditGuestUsernameModal extends WBComponent {
  @Ref() nameField!: HTMLInputElement;

  get username(): string {
    return this.state.user.username || "";
  }

  set username(newUsername: string) {
    UserMutations.setGuestUsername(this.$store.commit, newUsername);
  }

  get loginURL(): string {
    return `/accounts/login/?next=${window.location.pathname}`;
  }

  get maySubmit(): boolean {
    return this.username.length < 3;
  }

  mounted() {
    this.nameField.focus();
  }

  @Emit("done")
  onDone() {
    this.getters.wbcontroller.updateUsername(this.state.user.username);
    ModalMutations.closeModals(this.$store.commit);
  }
}
</script>

<style scoped lang="scss">
h2 {
  margin-top: 0;
}

form {
  input[type="text"] {
    width: 100%;
  }
}

.BottomRow {
  display: flex;
  justify-content: space-between;

  & > * {
    display: block;
  }
}
</style>
